import {
  texto,
  numero,
  construirHojaTabla,
  descargarLibro,
  limpiarNombreArchivo,
} from "../../../Components/ExcelTablaReporte";

export const exportarExplosionInsumos = ({ insumos, matrices, extras, serie, numero: folio, nombreProyecto, empresaNombre }) => {
  const encabezado = [serie, folio].filter(Boolean).join(" ");
  const descripcionFiltros = [encabezado && `Pre cotización ${encabezado}`, nombreProyecto].filter(Boolean).join(" · ");

  const filaInsumo = (insumo) => [texto(insumo.clave), texto(insumo.descripcion), texto(insumo.unidad), numero(insumo.cantidad)];
  const tituloBloque = (titulo) => [
    { ...texto(titulo), resalte: "insumoA" },
    { ...texto(""), resalte: "insumoA" },
    { ...texto(""), resalte: "insumoA" },
    { ...texto(""), resalte: "insumoA" },
  ];
  const principales = (insumos || []).filter((insumo) => insumo.principal);
  const otros = (insumos || []).filter((insumo) => !insumo.principal);
  const filasInsumos = [
    ...(principales.length ? [tituloBloque("MATERIAL"), ...principales.map(filaInsumo)] : []),
    ...(otros.length ? [tituloBloque(principales.length ? "OTROS INSUMOS" : "INSUMOS"), ...otros.map(filaInsumo)] : []),
  ];

  const hojaInsumos = construirHojaTabla(
    {
      columnas: [
        { titulo: "Clave", ancho: 18 },
        { titulo: "Descripción", ancho: 48 },
        { titulo: "Unidad", ancho: 14 },
        { titulo: "Cantidad total", ancho: 16 },
      ],
      filas: filasInsumos,
    },
    { titulo: "Explosión de insumos", empresaNombre, descripcionFiltros, sinAutofiltro: true, registros: (insumos || []).length }
  );

  const filasMatrices = [];
  (matrices || []).forEach((matriz) => {
    (matriz.componentes || []).forEach((componente) => {
      filasMatrices.push([
        texto(matriz.clave),
        texto(matriz.descripcion),
        numero(matriz.piezas),
        texto(componente.clave),
        texto(componente.descripcion),
        texto(componente.unidad),
        numero(componente.cantidad),
        componente.medida === undefined || componente.medida === null ? texto("") : numero(componente.medida),
        numero((Number(componente.cantidad) || 0) * (Number(matriz.piezas) || 0)),
        texto(componente.principal ? "Sí" : ""),
      ]);
    });
  });
  (extras || []).forEach((extra) => {
    filasMatrices.push([
      texto("EXTRA"),
      texto(extra.notas || ""),
      numero(extra.cantidad),
      texto(extra.clave),
      texto(extra.descripcion),
      texto(extra.unidad),
      numero(1),
      texto(""),
      numero(extra.cantidad),
      texto(""),
    ]);
  });

  const hojaMatrices = construirHojaTabla(
    {
      columnas: [
        { titulo: "Clave matriz", ancho: 16 },
        { titulo: "Matriz", ancho: 36 },
        { titulo: "Piezas", ancho: 10 },
        { titulo: "Clave insumo", ancho: 16 },
        { titulo: "Insumo", ancho: 40 },
        { titulo: "Unidad", ancho: 12 },
        { titulo: "Cantidad por pieza", ancho: 16 },
        { titulo: "Medida (cm)", ancho: 12 },
        { titulo: "Cantidad total", ancho: 16 },
        { titulo: "Principal", ancho: 10 },
      ],
      filas: filasMatrices,
    },
    { titulo: "Insumos por matriz", empresaNombre, descripcionFiltros }
  );

  descargarLibro(
    [
      { nombre: "Explosión de insumos", hoja: hojaInsumos },
      { nombre: "Insumos por matriz", hoja: hojaMatrices },
    ],
    limpiarNombreArchivo(`Explosion_insumos_${encabezado || "pre_cotizacion"}`)
  );
};
